/**
 * Accessibility Widget Scroll Animation
 * Shows the accessibility widget button with a smooth animation
 * only when the user has scrolled to the footer section
 */

(function() {
  'use strict';

  // CSS to hide the button initially and prepare for animation
  // Works on both mobile and desktop
  const style = document.createElement('style');
  style.textContent = `
    #accessiblyAppDialogButton {
      opacity: 0 !important;
      visibility: hidden !important;
      transform: translateY(20px) !important;
      transition: opacity 0.4s ease-in-out, visibility 0.4s ease-in-out, transform 0.4s ease-in-out !important;
    }
    
    #accessiblyAppDialogButton.show {
      opacity: 1 !important;
      visibility: visible !important;
      transform: translateY(0) !important;
    }
    
    /* Smooth animation works on both mobile and desktop */
  `;
  document.head.appendChild(style);

  function checkScrollPosition() {
    const footer = document.querySelector('.footer');
    const button = document.getElementById('accessiblyAppDialogButton');
    
    if (!footer || !button) {
      return;
    }

    // Get footer position relative to viewport
    // Works on both mobile and desktop
    const footerRect = footer.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    
    // Check if footer is visible in viewport
    // Show button when footer top is visible (user has scrolled to footer)
    // This works correctly on both mobile and desktop as getBoundingClientRect()
    // returns position relative to viewport regardless of device
    const shouldShow = footerRect.top <= windowHeight;
    
    if (shouldShow) {
      button.classList.add('show');
    } else {
      button.classList.remove('show');
    }
  }

  // Wait for DOM to be ready
  function init() {
    // Check if button exists (may be loaded by external script)
    const checkButton = setInterval(function() {
      const button = document.getElementById('accessiblyAppDialogButton');
      if (button) {
        clearInterval(checkButton);
        checkScrollPosition();
        
        // Listen to scroll events
        let ticking = false;
        window.addEventListener('scroll', function() {
          if (!ticking) {
            window.requestAnimationFrame(function() {
              checkScrollPosition();
              ticking = false;
            });
            ticking = true;
          }
        }, { passive: true });
        
        // Check on resize and orientation change (important for mobile)
        let resizeTimeout;
        window.addEventListener('resize', function() {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(function() {
            if (!ticking) {
              window.requestAnimationFrame(function() {
                checkScrollPosition();
                ticking = false;
              });
              ticking = true;
            }
          }, 150);
        }, { passive: true });
        
        // Also check on orientation change for mobile devices
        window.addEventListener('orientationchange', function() {
          setTimeout(function() {
            checkScrollPosition();
          }, 100);
        });
      }
    }, 100);
    
    // Stop checking after 10 seconds to avoid infinite loop
    setTimeout(function() {
      clearInterval(checkButton);
    }, 10000);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Also watch for dynamically added elements (for widgets that load after page load)
  const observer = new MutationObserver(function(mutations) {
    const button = document.getElementById('accessiblyAppDialogButton');
    if (button && !button.classList.contains('initialized')) {
      button.classList.add('initialized');
      checkScrollPosition();
      
      // Set up scroll listeners if not already set up
      let ticking = false;
      if (!window.__accessibilityWidgetScrollListener) {
        window.__accessibilityWidgetScrollListener = true;
        
        // Scroll listener for both mobile and desktop
        window.addEventListener('scroll', function() {
          if (!ticking) {
            window.requestAnimationFrame(function() {
              checkScrollPosition();
              ticking = false;
            });
            ticking = true;
          }
        }, { passive: true });
        
        // Resize listener with debounce
        let resizeTimeout;
        window.addEventListener('resize', function() {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(function() {
            if (!ticking) {
              window.requestAnimationFrame(function() {
                checkScrollPosition();
                ticking = false;
              });
              ticking = true;
            }
          }, 150);
        }, { passive: true });
        
        // Orientation change listener for mobile
        window.addEventListener('orientationchange', function() {
          setTimeout(function() {
            checkScrollPosition();
          }, 100);
        });
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

